import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const UnifiedPlatformShowcase = () => {
  return (
    <section className="py-24 bg-white overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Text Content on Top */}
        <motion.div
          initial={{ opacity: 0, y: -30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <div className="mb-6">
            <span className="text-blue-600 font-semibold text-sm uppercase tracking-wide">
              Seamless Integrations, Smarter Workflows
            </span>
          </div>

          <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-6 leading-tight max-w-4xl mx-auto">
            Turn Scattered Data into <span className="text-blue-600">Connected Intelligence</span>
          </h2>

          <div className="mb-8 max-w-3xl mx-auto">
            <h3 className="text-xl font-semibold text-gray-800 mb-4">One Platform. Endless Possibilities.</h3>
            <p className="text-lg text-gray-600 leading-relaxed">
              Stop juggling multiple tools. Ufficient unifies your entire workflow into one intelligent, secure, and scalable platform that connects all your data sources.
            </p>
          </div>

          <Link to="/contact">
            <button className="inline-flex items-center px-8 py-4 bg-blue-600 hover:bg-blue-700 text-white rounded-xl font-semibold transition-all duration-300 transform hover:-translate-y-1 group">
              Experience the Platform
              <svg className="w-5 h-5 ml-2 group-hover:translate-x-1 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
              </svg>
            </button>
          </Link>
        </motion.div>

        {/* Image Below */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="flex justify-center"
        >
          <div className="max-w-4xl w-full">
            <img 
              src="/images/Core.png" 
              alt="Ufficient Core Platform Architecture" 
              className="w-full h-auto object-contain"
            />
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default UnifiedPlatformShowcase; 